var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownNavy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0843 7.9584L16.4901 5.30186L19.7325 1.72153C19.7758 1.67376 19.8138 1.62239 19.8466 1.56829C20.0839 1.1764 20.0459 0.64142 19.7325 0.295367C19.3759 -0.0984557 18.7976 -0.0984557 18.441 0.295367L18.3133 0.436298L15.0483 4.0416L12.6425 6.69814L10 9.61607L7.35748 6.69814L4.95168 4.0416L1.68667 0.436297L1.55904 0.295367C1.20239 -0.0984557 0.62414 -0.0984557 0.267488 0.295367C-0.0459023 0.64142 -0.0839157 1.1764 0.153448 1.56829C0.186214 1.62239 0.224228 1.67376 0.267488 1.72153L3.50989 5.30186L5.91569 7.9584L9.1807 11.5637L9.30833 11.7046C9.49833 11.9144 9.75123 12.0125 10 11.9987C10.2488 12.0125 10.5017 11.9144 10.6917 11.7046L10.8193 11.5637L14.0843 7.9584Z",
    fill: "#22435e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownNavy);
export default __webpack_public_path__ + "static/media/arrow-down-navy.fd19b09bbbb7c6465904afc648f93816.svg";
export { ForwardRef as ReactComponent };